/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShareNetworkIcon20Regular = forwardRef('ShareNetworkIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.75 5a3.25 3.25 0 1 1 .876 2.22L8.152 9.205a3.256 3.256 0 0 1 0 1.59l3.475 1.985a3.25 3.25 0 1 1-.745 1.302l-3.423-1.956a3.25 3.25 0 1 1 0-4.252l3.422-1.956A3.253 3.253 0 0 1 10.75 5ZM14 3.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Zm-9 5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM12.25 15a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z" })));
});
